import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, Show, TS_AppTools, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_NLPModel } from '../ModuleFE_NLPModel.js';
import { sortArray } from '@nu-art/ts-common';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import './ATS_NLPModelEditor.scss';
import { QScrollWrapper } from '@app/hcs-frontend';
export class ATS_NLPModelEditor extends ComponentSync {
    // ######################### Static #########################
    static Screen = {
        key: 'nlp-model-editor',
        renderer: this,
        name: 'NLP Model Editor',
        group: 'Editors',
        modulesToAwait: [ModuleFE_NLPModel],
    };
    // ######################### Lifecycle #########################
    deriveStateFromProps(nextProps, state) {
        this.logInfo('Deriving');
        this.logInfo(ModuleFE_NLPModel.dbDef);
        state.models = this.getSortedModels();
        this.logInfo(state.models);
        if (!state.editedModel && state.models.length)
            state.editedModel = this.getEditableNLPModel(state.models[0]);
        return state;
    }
    // ######################### Logic #########################
    getSortedModels() {
        const models = ModuleFE_NLPModel.cache.allMutable();
        return sortArray(models, model => model.label);
    }
    getEditableNLPModel(model) {
        return new EditableDBItemV3(model ?? {}, ModuleFE_NLPModel)
            .setAutoSave(!!model?._id)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(model => {
            this.setState({
                models: this.getSortedModels(),
                editedModel: this.getEditableNLPModel(model),
            });
        }).setOnDelete(async (model) => {
            const models = this.getSortedModels();
            this.setState({
                models,
                editedModel: this.getEditableNLPModel(models[0]),
            });
        });
    }
    createNewModel = () => {
        this.setState({
            editedModel: this.getEditableNLPModel()
        });
    };
    // ######################### Render #########################
    render() {
        return _jsxs(_Fragment, { children: [TS_AppTools.renderPageHeader('NLP Model Editor'), this.renderBody()] });
    }
    renderBody = () => {
        return _jsxs(LL_H_C, { className: 'nlp-model-page', children: [this.renderList(), this.renderEditor()] });
    };
    renderList = () => {
        const models = this.state.models;
        const editable = this.state.editedModel;
        return _jsxs(LL_V_L, { className: 'nlp-model-page__list', children: [_jsx(QScrollWrapper, { children: models.map(model => {
                        const className = _className('nlp-model-page__list__item', model._id === editable?.item._id && 'selected');
                        return _jsx("div", { className: className, onClick: () => {
                                this.setState({
                                    editedModel: this.getEditableNLPModel(model),
                                });
                            }, children: model.label }, model._id);
                    }) }), _jsx("div", { className: 'nlp-model-page__list__add-new', onClick: this.createNewModel, children: "Create New Model" })] });
    };
    renderEditor = () => {
        const model = this.state.editedModel;
        if (!model)
            return;
        return _jsxs(LL_V_L, { className: 'nlp-model-page__editor', children: [_jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(DefaultEditor_InputText, { editable: model, prop: 'label' }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Key', children: _jsx(DefaultEditor_InputText, { editable: model, prop: 'key' }) }), this.renderEditorButtons()] });
    };
    renderEditorButtons = () => {
        const model = this.state.editedModel;
        if (!model)
            return;
        return _jsx(LL_H_C, { className: 'nlp-model-page__editor__buttons', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: !!model?.item._id, children: _jsx(Button, { variant: 'dangerous', className: 'button_delete', onClick: async () => await model.delete(), children: "Delete" }) }), _jsx(Show.If, { condition: !model?.item._id, children: _jsx(Button, { variant: 'primary', className: 'button_save', onClick: async () => await model.save(), children: "Save" }) })] }) });
    };
}
//# sourceMappingURL=ATS_NLPModelEditor.js.map